import { useCallback, useMemo, useState } from 'react';
import { nextTick, useMinLoadingState, useOnStateChange } from '@frameio/vapor';

type Options<T> = {
  activeEntity: T;
};

type Callback = () => void;

export function useNextTickActivation<T>({ activeEntity }: Options<T>) {
  const [pending, setPending] = useState<T | null>(null);

  const isPendingVisible = useMinLoadingState(Boolean(pending), 400);

  const activate = useCallback((id: T, fn: Callback) => {
    setPending(id);
    nextTick(fn);
  }, []);

  useOnStateChange(activeEntity, () => {
    setPending(null);
  });

  const state = pending === null ? activeEntity : pending;

  const context = useMemo(() => {
    return {
      state,
      activate,
    };
  }, [activate, state]);

  return {
    context,
    isPending: isPendingVisible,
  };
}
